var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IntroVideoWorkspace',{attrs:{"type":"story"}})
}
var staticRenderFns = []

export { render, staticRenderFns }